import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { ReportHtml } from 'tms-lib';
import {
  SalesManifest,
  SalesManifestAddRemove,
  SalesManifestDetails,
  SalesManifestEmailContacts,
  SalesManifestItemDetails,
  SalesManifestItems,
} from '../../../models';
import { TmsWebBaseEditCreateCopyService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesManifestService extends TmsWebBaseEditCreateCopyService<SalesManifest, SalesManifestDetails> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesManifest', $localize`Sales Manifest`);
  }

  createSalesManifests(ids: string[]): Observable<string[]> {
    return this.httpService.post<string[]>(`${this.apiUrl}/CreateSalesManifests`, { ids });
  }

  removeFromSalesManifest(salesManifestAddRemove: SalesManifestAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/RemoveFromSalesManifest`, salesManifestAddRemove);
  }

  addToSalesManifest(salesManifestAddRemove: SalesManifestAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/AddToSalesManifest`, salesManifestAddRemove);
  }

  getSalesManifestEmailContacts(id: string): Observable<SalesManifestEmailContacts> {
    return this.httpService.get<SalesManifestEmailContacts>(`${this.apiUrl}/SalesManifestEmailContacts?id=${id}`);
  }

  getCreatedSalesManifests(ids: string[]): Observable<SalesManifest[]> {
    return this.httpService.post<SalesManifest[]>(`${this.apiUrl}/CreatedSalesManifests`, { ids });
  }

  getSalesManifestReportHtml(id: string): Observable<string> {
    return this.httpService
      .get<ReportHtml>(`${this.apiUrl}/SalesManifestReportHtml/${id}`)
      .pipe(map((model: ReportHtml) => model.html));
  }

  getSalesManifestItemDetails(id: string): Observable<SalesManifestItemDetails[]> {
    return this.httpService.get<SalesManifestItemDetails[]>(`${this.apiUrl}/GetSalesManifestItemDetails/${id}`);
  }

  getSalesManifestItems(search: string, fromDate: Date, toDate: Date): Observable<SalesManifestItems[]> {
    return this.httpService.get<SalesManifestItems[]>(
      `${this.apiUrl}/SalesManifestItems?search=${search}&fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
    );
  }
}
